
/**
 * `BusinessUnitSwitch` - The BU switch "Business unit switch" is a row of cards leading to the external pages of other Mercedes-Benz business units.
 */
import ComponentInitializeDispatcher from '@owc-utils/Mixins/ComponentInitializeDispatcher';
import BusinessUnit from './BusinessUnit.vue';
import { BusinessUnitSwitchComponent } from './BusinessUnitSwitch';
import ValidationBoxWrapper from '@owc-packages/ValidationBox/src';

import OwcDataComponent from '@owc-utils/Mixins/OwcDataComponent';
export default (ComponentInitializeDispatcher as BusinessUnitSwitchComponent).extend({
  name: 'owc-business-unit-switch',
  components: {
    BusinessUnit,
    ValidationBoxWrapper,
  },
  mixins: [OwcDataComponent],
});
